import styled from 'styled-components'
import { Button } from '@mui/material';

export const CadastrarOcorrenciaButton = styled(Button)`
    width: 200px;
`
